import React from "react";
import { Col, Row, Select, Input } from "antd";
import { CDBIcon } from "cdbreact";
import { Button } from "react-bootstrap";

export const FiltersPanel = ({ filtros, uniqueBanks, uniqueMethods, handleInputChange, handleSelectChange, limpiarFiltros, selectableColumns, setSelectedColumns }) => {
  return (
    <>
      <p className="fw-bold" style={{ color: "#3E4144", fontSize: '20px', fontFamily: 'Montserrat, sans-serif', textAlign: 'left', paddingLeft: '50px' }}>Opciones de Filtrado</p>
      <Row className='d-flex justify-content-left' style={{ paddingLeft: '40px' }} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6} lg={4}>
              <Input placeholder="Id de transacción" value={filtros.transaccionId} onChange={(e) => handleInputChange(e, 'transaccionId')} />
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
              <Input placeholder="Últimos 4 dígitos" maxLength={4} value={filtros.ultimos4} onChange={(e) => handleInputChange(e, 'ultimos4')} />
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
              <Select className="w-100" placeholder="Estado" value={filtros.status || undefined} onChange={(value) => handleSelectChange(value, "status")} options={[{ value: "approvedTransaction", label: "Aprobada" }, { value: "declinedTransaction", label: "Rechazada" }]} allowClear />
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
              <Select className="w-100" placeholder="Banco" value={filtros.bank || undefined} onChange={(value) => handleSelectChange(value, "bank")} options={uniqueBanks} showSearch allowClear />
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
              <Select className="w-100" placeholder="Método" value={filtros.method || undefined} onChange={(value) => handleSelectChange(value, "method")} options={uniqueMethods} showSearch allowClear />
          </Col>
      </Row>
      
      <Row className='m-3' gutter={[8, 16]} style={{ padding: '5px', paddingLeft: '35px', gap: '10px', alignItems: 'center' }}>
          <Col>
            <Select mode="multiple" className="w-100" style={{minWidth: '200px'}} showSearch placeholder="Mostrar/Ocultar Columnas" onChange={setSelectedColumns}
              options={selectableColumns.map(col => ({ value: col.key, label: col.label }))}
            />
          </Col>
          <Col>
            <Button onClick={limpiarFiltros} style={{ borderRadius: '20px', backgroundColor: '#F2F2F2', color: '#9A9A9A', border: '1px solid #CCCCCC', padding: '8px 16px' }} className='fw-bold'>
              <CDBIcon icon="trash" className="me-2" /> Borrar filtros
            </Button>
          </Col>
      </Row>
    </>
  );
};